export default "__VITE_ASSET__BQiwuPfv__"